import { combineReducers } from "redux";

import themeReducer from "./themeReducer";
import authReducer from "./authReducer";

const rootReducer = combineReducers({
  themeReducer,
  authReducer,
});
// eslint-disable-next-line
export default (state, action) =>
  rootReducer(action.type === "GET_LOGOUT" ? undefined : state, action);
